export const MOBILE_SPLASH_EXPIRATION = 0;

export const MOBILE_SPLASH_DURATION = 3500;
